// BiographyPageSettingServices.js
import API from "../../api/apiAdmin";

export const BiographyPageSettingServices = {
    getSettings: async () => {
        try {
            const response = await API.get("/admin/biography-settings/");
            return response.data;
        } catch (error) {
            throw error.response ? error.response.data : new Error("Network error");
        }
    },

    updateSettings: async (formData) => {
        try {
            // Since we're sending an image, we need to use FormData
            const data = new FormData();
            Object.keys(formData).forEach(key => {
                if (key === 'bio_image' && formData[key]) {
                    data.append('bio_image', formData[key]);
                } else if (formData[key] !== null && formData[key] !== undefined) {
                    data.append(key, formData[key]);
                }
            });

            const response = await API.put("/admin/biography-settings/", data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response ? error.response.data : new Error("Network error");
        }
    }
};
